// core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// workspace
import { MaterialModule } from '@campfire-nx/material';
import { OpenModule } from '@campfire-nx/open';
import { GamutModule } from '@campfire-nx/gamut';

// components
import { PartnerStyleComponent } from './partner-style/partner-style.component';
import { MagicLinkFormComponent } from './magic-link-form/magic-link-form.component';
import { EntityCardComponent } from './entity-card/entity-card.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { ProductCalloutComponent } from './product-callout/product-callout.component';
import { ProductHeroBannerComponent } from './product-hero-banner/product-hero-banner.component';
import { ProductCrossContentComponent } from './product-cross-content/product-cross-content.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { ProductTextBlockComponent } from './product-text-block/product-text-block.component';
import { ProductAccordionComponent } from './product-accordion/product-accordion.component';
import { ProductFeaturesComponent } from './product-features/product-features.component';
import { ProductFeaturesTableComponent } from './product-features-table/product-features-table.component';
import { ProductTrustpilotComponent } from './product-trustpilot/product-trustpilot.component';
import { ProductBannerComponent } from './product-banner/product-banner.component';
import { ProductSummaryComponent } from './product-summary/product-summary.component';

// pipes
import { StringInjectionPipe } from '@open-portal-app/core/pipes/stringInjection.pipe';

@NgModule({
  declarations: [
    PartnerStyleComponent,
    MagicLinkFormComponent,
    EntityCardComponent,
    UserMenuComponent,
    ProductCalloutComponent,
    ProductHeroBannerComponent,
    ProductCrossContentComponent,
    ProductCardComponent,
    ProductTextBlockComponent,
    ProductAccordionComponent,
    ProductFeaturesComponent,
    ProductFeaturesTableComponent,
    ProductTrustpilotComponent,
    ProductBannerComponent,
    ProductSummaryComponent,
    StringInjectionPipe
  ],
  imports: [
    CommonModule,
    GamutModule,
    MaterialModule,
    ReactiveFormsModule,
    OpenModule,
  ],
  exports: [
    PartnerStyleComponent,
    MagicLinkFormComponent,
    EntityCardComponent,
    UserMenuComponent,
    GamutModule,
    ProductCalloutComponent,
    ProductHeroBannerComponent,
    ProductCrossContentComponent,
    ProductCardComponent,
    ProductTextBlockComponent,
    ProductAccordionComponent,
    ProductFeaturesComponent,
    ProductFeaturesTableComponent,
    ProductTrustpilotComponent,
    ProductBannerComponent,
    ProductSummaryComponent
  ]
})
export class ComponentsModule { }
